// Property details select values
export const bathroomAmenities = [
  { id: 1, name: "Douchekabine" },
  { id: 2, name: "Dubbele wastafel" },
  { id: 3, name: "Inloop douche" },
  { id: 4, name: "Jacuzzi" },
  { id: 5, name: "Ligbad" },
  { id: 6, name: "Sauna" },
  { id: 7, name: "Toilet" },
  { id: 8, name: "Wastafel" },
];

export const outdoorSpace = [
  { id: 1, name: "Balkon" },
  { id: 2, name: "Dakterras" },
  { id: 3, name: "Frans balkon" },
  { id: 4, name: "Niet van toepassing" },
  { id: 5, name: "Terras" },
  { id: 6, name: "Tuin" },
];

export const deposit = [
  { id: 1, name: "1x de mandhuur" },
  { id: 2, name: "1,5x de mandhuur" },
  { id: 3, name: "2x de mandhuur" },
  { id: 4, name: "3x de mandhuur" },
];

export const constructionYear = [
  { id: 1, name: "voor 1906" },
  { id: 2, name: "1906-1930" },
  { id: 3, name: "1931-1944" },
  { id: 4, name: "1945-1959" },
  { id: 5, name: "1960-1970" },
  { id: 6, name: "1971-1980" },
  { id: 7, name: "1981-1990" },
  { id: 8, name: "1991-2000" },
  { id: 9, name: "2001-2010" },
  { id: 10, name: "Na 2010" },
  { id: 11, name: "2023" },
];

export const energielabel = [
  { id: 1, name: "A" },
  { id: 2, name: "A+" },
  { id: 3, name: "A++" },
  { id: 4, name: "A+++" },
  { id: 5, name: "B" },
  { id: 6, name: "C" },
  { id: 7, name: "D" },
  { id: 8, name: "E" },
  { id: 9, name: "F" },
  { id: 10, name: "G" },
  { id: 11, name: "Niet van toepassing" },
];

export const floors = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4+" },
];

export const sort = [
  { id: 1, sortKey: "date", name: "select.date_desc" },
  { id: 2, sortKey: "price-asc", name: "select.price_asc" },
  { id: 3, sortKey: "price-desc", name: "select.price_desc" },
];
export const construction = [
  { id: 1, name: "Bestaande bouw" },
  { id: 2, name: "Nieuwbouw" },
];

export const status = [
  { id: 1, name: "Alle" },
  { id: 2, name: "Beschikbaar" },
  { id: 3, name: "Verhuurd" },
];
export const upholstered = [
  { id: 1, name: "Alle" },
  { id: 2, name: "Niet Gestoffeerd" },
  { id: 3, name: "Wel Gestoffeerd" },
];
export const furnished = [
  { id: 1, name: "Alle" },
  { id: 2, name: "Niet Gestoffeerd" },
  { id: 3, name: "Wel Gestoffeerd" },
];

// Tenant check select values
export const viewingOptions = [
  {
    id: 1,
    name: "screening.dropdowns.viewing_options.on_location",
    viewing: true,
    videoViewing: false,
  },
  {
    id: 2,
    name: "screening.dropdowns.viewing_options.video",
    viewing: false,
    videoViewing: true,
  },
  { id: 3, name: "screening.dropdowns.viewing_options.both", viewing: true, videoViewing: true },
];

export const rentalPeriod = [
  { id: "6 maanden", name: "screening.dropdowns.rental_period.6_months", other: false },
  { id: "1 jaar", name: "screening.dropdowns.rental_period.1_year", other: false },
  { id: "1,5 jaar", name: "screening.dropdowns.rental_period.1_5_years", other: false },
  { id: "2 jaar", name: "screening.dropdowns.rental_period.2_years", other: false },
  { id: "Langer dan 2 jaar", name: "screening.dropdowns.rental_period.more_than_2_years", other: false },
  { id: "Overig", name: "screening.dropdowns.rental_period.other", other: true },
];

export const adultsInHousehold = [
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5+" },
];

export const kidsInHousehold = [
  { id: 0, name: "0" },
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5+" },
];
